import type { GatsbyBrowser } from 'gatsby';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {};

export default onClientEntry;
